// extracted by mini-css-extract-plugin
export default {"root":"_2zhl9","status-indicator":"_1_yFE","statusIndicator":"_1_yFE"};